export const ledsMoveMethod = {
  moveUpCondition: item => {
    return false;
  },
  moveDownCondition: item => {
    return false;
  },
  moveUp(item, accessories, index) {
    return false;
  },
  moveDown(item, accessories, index) {
    return false;
  },
  switchAltitude: (prevAltitude, item, index) => {
    const { position } = item;
    const [, max] = position;
    return max;
  },
};
